import { useQuery } from "react-query";
import { getRole } from "~/pages/RegistryOfRole/rolesRequest/getRole";

export default function useGetRole(id: string) {
  return useQuery({
    queryKey: ["getRole", id],
    queryFn: () => getRole(id),
    refetchOnWindowFocus: false,
    enabled: id !== "add" && !!id,
    cacheTime: 0,
    onSuccess: (data) => {
      console.log("useGetRole success:", data);
    },
    onError: (error) => {
      console.error("useGetRole error:", error);
    },
  });
}
